<template>
    <div>
        <h2 class="flex flex-col items-start gap-2 text-xl font-bold text-white py-2 sm:flex-row sm:items-center">
            {{ $t('setup.userInfo') }}
        </h2>
        <div class="flex flex-col gap-3 rounded-md text-white p-7 mb-16 bg-gray-900/50 shadow-sm ring-1 ring-inset ring-gray-900">
            <div v-if="user">
                <div v-for="field in fields" :key="field.key" class="mb-3 sm:col-span-4 block text-sm leading-6 text-left text-white">
                    <span class="font-black">{{ $t(field.label) }}:</span> {{ show(field.key) }}
                </div>
            </div>
            <button
                type="button"
                class="primary sm:w-fit"
                @click="$emit('edit', user)"
            >
                {{ $t('common.edit') }}
            </button>
        </div>
    </div>
</template>

<script>
import { LOCALES } from '@/i18n';

// Account details of the logged-in user
export default {
    props: {
        user: {
            type: Object,
            default: null,
        },
    },
    emits: ['edit'],
    methods: {
        // the language is kept as a code ('pt-BR') and shown by its name
        show(key) {
            const value = this.user[key];
            if (key === 'locale') {
                const language = LOCALES.find((option) => option.code === value);
                return language ? language.name : '-';
            }
            return value;
        },
    },
    data() {
        return {
            fields: [
                { key: 'user_id', label: 'fields.id' },
                { key: 'name', label: 'fields.name' },
                { key: 'username', label: 'fields.username' },
                { key: 'email', label: 'fields.email' },
                { key: 'locale', label: 'fields.language' },
            ],
        };
    },
};
</script>
